import { Directive, forwardRef, Input } from '@angular/core';
import { NG_VALIDATORS, AbstractControl, ValidationErrors, Validator } from '@angular/forms';

@Directive({
  selector: '[paraguayanRuc]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => ParaguayanRucValidatorDirective),
      multi: true
    }
  ]
})
export class ParaguayanRucValidatorDirective implements Validator {
  @Input('paraguayanRuc') shouldValidate: boolean;
  @Input('contributorType') contributorType: any;

  validate(control: AbstractControl): ValidationErrors | null {
    // Solo validar si shouldValidate es true
    if (!this.shouldValidate) {
      return null;
    }

    if (!control.value) {
      return null; // No validar si está vacío (usar required para eso)
    }

    const ruc = control.value.toString().replace(/\s/g, ''); // Remover espacios

    // Verificar que no contenga guión
    if (ruc.includes('-')) {
      return { rucWithHyphen: true };
    }

    // Verificar que tenga exactamente 9 dígitos (8 + 1 verificador)
    // Solo para contribuyentes que NO sean personas físicas (contributorType != 1)
    const isPersonaFisica = this.contributorType && this.contributorType.toString() === '1';
    if (!isPersonaFisica && !/^\d{9}$/.test(ruc)) {
      return { invalidRucFormat: true };
    }

    return null; // RUC válido
  }
}
